<template>
    <div @click="(event) => isOutside(event)">
       <modal class="modal-wrapper" :width="width" :height="height" @hide-modal="$emit('hide-modal')">
        <template v-slot:content>
            <div class="modal-inner px-2 py-1" v-if="formSteps.length !== 0">
                <IntakeForm class="relative" v-if="formSteps[currentStep].formTitle" :steps="formatFormSteps(formSteps[currentStep].questions)" :fieldsToMonitor="fieldsToMonitor(formSteps[currentStep].questions)" @submitHandler="submitHandler" :showButton="true" :buttonText="'Submit'"
                 :exitButtonText="'Continue Browsing'" @progress="next" @hide-modal="$emit('hide-modal')">
                    <template v-slot:content>
                        <div class="text-left">
                            <div class="title-padding text-2xl font-bold">{{formSteps[currentStep].formHeader}}</div>
                            <hr class="bottom-border"/>
                            <div class="title-padding text-base">{{formSteps[currentStep].formSubHeader}}</div>
                        </div>
                    </template>
                </IntakeForm>
                <component
                    v-else
                    :is="formSteps[currentStep].type"
                    :isAnonymous='isAnonymousCustomer'
                    :step="formSteps[currentStep]"
                    :showButton="true"
                    @progress="next"
                >
                <template v-slot:header-content>
                    <div class="text-left space-bottom-1">
                        <div class="text-2xl font-bold title-padding" v-if="formSteps[currentStep].title">{{formSteps[currentStep].title}}</div>
                        <hr class="bottom-border"/>
                        <div class="text-base title-padding" v-if="formSteps[currentStep].bodyText">{{formSteps[currentStep].bodyText}}</div>
                    </div>
                </template>
                </component>
            </div>
        </template>
       </modal>
    </div>
            
</template>

<script>
import { mapMutations } from 'vuex';
import IntakeForm from './IntakeForm';
import Modal from '../../utils/modal';
import { WebstoreResources } from "../../../mixins/webstore-resources";
import informational from "./Information.vue"
import { getByContentType } from "../../../plugins/contentful"
import Resize from '../webstore/mixins/resizeMixin'
export default {
    components: {IntakeForm, Modal, informational},
    mixins: [WebstoreResources, Resize],
    data() {
      return {
        formSteps: [],
        currentStep: 0
      }
    },
    computed: {
        width() {
            return window.innerWidth > 550 ? '600px' : '90%';
        },
        height() {
            return window.innerWidth > 550 ? 'auto' : '90%';
        }
    },
    methods: {
        ...mapMutations('webstoreForm', ['setInquiryModalSubmitted']),
        formatFormSteps(formSteps) {
            return formSteps.map((step) => step.fields);
        },
        next(){
            this.currentStep++;
            if(this.currentStep === this.formSteps.length){
                this.$emit('hide-modal')
            }
        },
        isOutside(event) {
            if(!event.target.closest('.modal-inner')){
                this.$emit('hide-modal')
            }
        },
        fieldsToMonitor(formFields){
            let fields = []
            for(let i = 0; i < formFields.length; ++i){
                fields.push(formFields[i]?.fields?.name)
            }
            return fields;
        },
        submitHandler(value){
            this.submitAnonymousLargeFleetLead(value);
            this.anonymousLeadSubmissionTracking("inquiry-modal") 
            this.setInquiryModalSubmitted(true);
        }
    },
    mounted() {
        this.resize()
    },
    async created(){
        const form = await getByContentType("anonymousPricingForm", "en-US", {include : 10, "fields.formTitle": "Anonymous Inquiry Modal"});
        this.formSteps = this.formatFormSteps(form.questions);
     },
}
</script>

<style lang="scss" scoped>
input[type=tel] {
    border: 3px solid #0384FB;
    box-sizing: border-box;
}

hr.bottom-border {
    width:100% !important
}
.modal-wrapper ::v-deep .close {
        width: 18px !important;
        height: 18px !important;
        top: 3px;
        left: 90%;
    }

.modal-wrapper ::v-deep .close:before {
    height: 18px !important;
}

.modal-wrapper ::v-deep .close:after {
    height: 18px !important;
}

.header-style{
    padding-bottom: 3px;
}

.title-padding{
    padding-top: 10px;
    padding-bottom: 10px;
}
</style>